(function () {
    'use strict';

    angular
        .module('app')
        .service('policiesService', service);

    service.$inject = ['$http', 'urlHelper', '$sessionStorage', 'handleException'];

    /** @ngInject */
    function service($http, urlHelper, $sessionStorage, handleException) {

        this.getPolicyByNumber = function (policyNumber) {
            var url = urlHelper.getSuperbrandApiUrl() +
                'policies/' + encodeURIComponent(policyNumber);

            return $http.get(url).then(function (response) {
                return response.data;
            });
        };

        this.getByPolicyholderId = function (policyholderId) {
            var url = urlHelper.getSuperbrandApiUrl() +
                'policyholders/' + encodeURIComponent(policyholderId) +
                '/policies';

            return $http.get(url).then(function (response) {
                return response.data;
            });
        }

        this.getPolicyAttachments = function (policyNumber) {
            var url = urlHelper.getSuperbrandApiUrl() +
                'policies/' + encodeURIComponent(policyNumber) +
                '/attachments';

            return $http.get(url).then(function (response) {
                return response.data;
            });
        }

        this.getPolicyDocuments = function (policyNumber) {
            var sessionId = JSON.parse(sessionStorage.getItem("ngStorage-sessionId"));
            if (sessionId) {
                return $http.get(urlHelper.getSuperbrandApiUrl() + "memberswebapi/sessions/" + sessionId + "/policies/" + policyNumber + "/documents")
                    .then(function (result) {
                        return result;
                    }, function (error) {
                        handleException.log(error);
                        throw error;
                    });
            }
            return null;
        }

        this.setAutoRenewalOptOut = function (policyNumber, request) {
            var sessionId = JSON.parse(sessionStorage.getItem("ngStorage-sessionId"));
            if (sessionId) {
                return $http.patch(urlHelper.getSuperbrandApiUrl() + "memberswebapi/sessions/" + sessionId + "/policies/" + policyNumber, request)
                    .then(function (result) {
                        return result;
                    }, function (error) {
                        handleException.log(error);
                    });
            }
            return null;
        }

        this.createQuote = function (policyNumber) {
            var sessionId = JSON.parse(sessionStorage.getItem("ngStorage-sessionId"));
            if (sessionId) {
                return $http.post(urlHelper.getSuperbrandApiUrl() + "memberswebapi/sessions/" + sessionId + "/policies/" + policyNumber + "/quotes")
                    .then(function (result) {
                        return result;
                    }, function (error) {
                        handleException.log(error);
                    });
            }
            return null;
        }

        this.createVoucher = function (policyNumber, request, sessionId) {
            const url = `${urlHelper.getSuperbrandApiUrl()}memberswebapi/sessions/${sessionId}/policies/${policyNumber}/vouchers`;

            return $http.post(url, request).then(function (response) {
                return response.data;
            })
        }

        this.createQuote = function (policyNumber) {
            var sessionId = JSON.parse(sessionStorage.getItem("ngStorage-sessionId"));
            if (sessionId) {
                return $http.post(urlHelper.getSuperbrandApiUrl() + "memberswebapi/sessions/" + sessionId + "/policies/" + policyNumber + "/quotes")
                    .then(function (result) {
                        return result;
                    }, function (error) {
                        handleException.log(error);
                    });
            }
            return null;
        }
    }
}());
